// ===================================================================
// KAIXO - Emoji Picker mínimo (sin dependencias)
// ===================================================================
// Popup con grid de emojis comunes. Sin librerías externas — ~3 KB.
// Para caption de Latido y comentarios. Cubre ~150 emojis populares
// en 6 categorías. Si en el futuro se quiere catálogo completo, se
// puede sustituir por emoji-mart sin cambiar la API.
//
// Uso:
//   <EmojiPicker open={show} onPick={emoji => ...} onClose={() => ...} />
// ===================================================================

import React from 'react';
import './EmojiPicker.css';

const CATEGORIES = [
    {
        name: 'Caritas',
        emojis: ['😀','😃','😄','😁','😆','😅','🤣','😂','🙂','🙃','😉','😊','😇','🥰','😍','🤩','😘','😗','😚','😙','😋','😛','😜','🤪','😝','🤑','🤗','🤔','🤐','😐','😑','😶','😏','😒','🙄','😬','🤥','😌','😔','😪','🤤','😴','😷','🤒','🤕','🤧','🥵','🥶','🤯','🤠','🥳','😎','🤓','🧐','😕','😟','🙁','☹️','😮','😯','😲','😳','🥺','😦','😧','😨','😰','😥','😢','😭','😱','😖','😣','😞','😓','😩','😫','🥱','😤','😡','😠','🤬']
    },
    {
        name: 'Gestos',
        emojis: ['👍','👎','👌','✌️','🤞','🤟','🤘','🤙','👈','👉','👆','🖕','👇','☝️','👋','🤚','🖐️','✋','🖖','👏','🙌','🤲','🙏','✍️','💪','🦾','🦿','🦵','🦶','👂','🦻','👃','🧠','👀','👁️','👅','👄']
    },
    {
        name: 'Corazones',
        emojis: ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖','💘','💝','💟','♥️']
    },
    {
        name: 'Viajes',
        emojis: ['✈️','🛬','🛫','🚢','⛵','🚗','🚕','🚙','🚌','🚎','🏎️','🚓','🚑','🚒','🚐','🛻','🚚','🚛','🚜','🛵','🏍️','🛴','🚲','🛺','🚁','🚂','🚆','🚊','🚉','🚍','🚞','🚄','🌍','🌎','🌏','🗺️','🧳','🏝️','🏔️','⛱️','🏖️','🏕️','🌋','🗻','🏞️']
    },
    {
        name: 'Comida',
        emojis: ['🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🫐','🍈','🍒','🍑','🥭','🍍','🥥','🥝','🍅','🍆','🥑','🥦','🥬','🥒','🌶️','🫑','🌽','🥕','🧄','🧅','🥔','🍠','🥐','🥯','🍞','🥖','🥨','🧀','🥚','🍳','🧈','🥞','🧇','🥓','🥩','🍗','🍖','🌭','🍔','🍟','🍕','🥪','🌮','🌯','🫔','🥙','🧆','🥗','🥘','🫕','🥫','🍝','🍜','🍲','🍛','🍣','🍱','🥟','🦪','🍤','🍙','🍚','🍘','🍢','🍡','🍧','🍨','🍦','🥧','🧁','🍰','🎂','🍮','🍭','🍬','🍫','🍿','🍩','🍪','🌰','🥜','🍯','🥛','🍼','☕','🫖','🍵','🍶','🍾','🍷','🍸','🍹','🍺','🍻','🥂','🥃','🥤','🧋','🧃','🧉','🧊']
    },
    {
        name: 'Objetos',
        emojis: ['💯','🔥','✨','⭐','🌟','💫','💥','💢','💨','💦','💤','🎉','🎊','🎈','🎁','🎀','🏆','🥇','🥈','🥉','⚽','🏀','🎮','🎯','🎲','🧩','📱','💻','⌨️','🖥️','🖱️','💾','💿','📀','📷','📸','🎥','📹','📺','📻','🎙️','📞','☎️','📲','💡','🔦','🕯️','💰','💸','💵','💴','💶','💷','💳','🧾','✉️','📧','📨','📩','📪','📫','📬','📭','📮','📦','📚','📖','✏️','✒️','🖊️','🖋️','📝','💼','📁','📂','🗂️','📅','📆','🗓️','📇','📈','📉','📊','📋','📌','📍','🚩','🏁','🌈','☀️','⛅','☁️','🌧️','⛈️','🌩️','❄️','☃️','⛄','🌬️','🌊']
    }
];

export default function EmojiPicker({ open, onPick, onClose }) {
    if (!open) return null;
    return (
        <div className="kx-emoji-picker" onClick={e => e.stopPropagation()}>
            <div className="kx-emoji-picker-header">
                <span>Emojis</span>
                <button className="kx-emoji-close" onClick={onClose} aria-label="Cerrar">×</button>
            </div>
            <div className="kx-emoji-picker-body">
                {CATEGORIES.map(cat => (
                    <div key={cat.name} className="kx-emoji-category">
                        <div className="kx-emoji-cat-name">{cat.name}</div>
                        <div className="kx-emoji-grid">
                            {cat.emojis.map((em, i) => (
                                <button
                                    key={`${cat.name}-${i}`}
                                    className="kx-emoji-btn"
                                    onClick={() => onPick(em)}
                                    type="button"
                                    aria-label={em}
                                >
                                    {em}
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
